const setLoadingRooms = (state, payload) => {
  state.loadingRooms = payload
}

const setSelectedRooms = (state, payload) => {
  localStorage.setItem('selectedRooms', JSON.stringify(payload))
  state.selectedRooms = payload
}

const setRooms = (state, payload) => {
  state.rooms = payload
}

export default {
  setLoadingRooms,
  setSelectedRooms,
  setRooms
}
